module.exports = __webpack_public_path__ + "static/media/user.0e76afb2.svg";